'use client';

import { useState } from 'react';
import clsx from 'clsx';

import Tag from '@repo/ui/Tag';
import { VpIcon } from '@vtmn-play/react';

import { ActionCardProps } from './ActionCard.props';

import './ActionCard.scss';

const ActionCard = ({
  action,
  as,
  className,
  extra,
  i18n = { showTertiary: 'Show more' },
  id,
  illustration,
  primary,
  secondary,
  tertiary,
}: ActionCardProps) => {
  const [showTertiary, setShowTertiary] = useState(false);

  return (
    <Tag className='action-card-container' tagName={as}>
      <div className={clsx('action-card', className)}>
        {illustration && (
          <div className='action-card-illustration'>{illustration}</div>
        )}

        <div className='action-card-labels'>
          <div className='action-card-primary'>{primary}</div>
          {secondary && (
            <div className='action-card-secondary'>{secondary}</div>
          )}

          {extra && <div className='action-card-extra'>{extra}</div>}

          {tertiary && (
            <button
              aria-controls={`desc-${id}`}
              aria-expanded={showTertiary}
              className='action-card-tertiary-toggle'
              onClick={() => setShowTertiary(!showTertiary)}
              type='button'
            >
              <span>{i18n.showTertiary}</span>
              <VpIcon
                className={clsx('chevron', showTertiary && 'chevron-open')}
                name='chevron-down'
                size={16}
              />
            </button>
          )}

          {tertiary && showTertiary && (
            <div className='action-card-tertiary' id={`desc-${id}`}>
              {tertiary}
            </div>
          )}
        </div>

        {action && <div className='action-card-action'>{action}</div>}
      </div>
    </Tag>
  );
};

export default ActionCard;
